export const MIN_DAYS_TO_ACCEPT_OFFER_WITH_CREDIT = 5
